$(window).on('load', function () {
    $('.c-hippo-price__price').addClass('c-hippo-price__price--animated');

    $('.c-hippo-price__number').each(function() {

        $(this).prop('Counter', 0).animate({
            
            Counter: $(this).data('number')
        }, {
            
            duration: 1500,
            easing: 'swing',
            step: function(now) {
                
                $(this).text(Math.ceil(now).toLocaleString('en'));
            }
        });

    });
});